/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Remove_List_LabelInputs */



/**
* | output |
* | --- |
* | "Remove Marker List" |
*
* @param {Markers_Remove_List_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_remove_list_label = /** @type {((inputs?: Markers_Remove_List_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Remove_List_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la liste de marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markerliste entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi elenco marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить список маркеров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar lista de marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除标记列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーリストを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर सूची हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover lista de marcadores")
	return /** @type {LocalizedString} */ ("Remove Marker List")
});